module.exports = __webpack_public_path__ + "img/edge_hiver_ski_nordique.93074aa7.svg";